import React, { useEffect, useState } from 'react';
export function CountdownPage() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date('2026-02-01T00:00:00').getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      }
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => String(num).padStart(2, '0');
  return <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4 relative overflow-hidden" data-id="element-69">
      {/* Animated background gradient */}
      <div className="absolute inset-0 opacity-20" data-id="element-70">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600 rounded-full blur-[120px] animate-pulse" data-id="element-71"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-600 rounded-full blur-[120px] animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-72"></div>
      </div>

      <div className="relative z-10 text-center" data-id="element-73">
        {/* Logo - Más pequeño */}
        <div className="mb-12 animate-fade-in" data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/qxKLGQczqeyzmB6PfiAg11/Asset_11x.png" alt="Brixen Credit" className="h-10 md:h-12 w-auto mx-auto" data-id="element-75" />
        </div>

        {/* Date */}
        <div className="mb-12 animate-slide-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-76">
          <div className="text-white/40 text-sm md:text-base font-light tracking-[0.3em] mb-2" data-id="element-77">
            LANZAMIENTO
          </div>
          <div className="text-white text-4xl md:text-6xl font-light tracking-wider" data-id="element-78">
            01.02.2026
          </div>
        </div>

        {/* Countdown Timer */}
        <div className="mb-16 animate-scale-in" style={{
        animationDelay: '0.4s'
      }} data-id="element-79">
          <div className="grid grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto" data-id="element-80">
            {/* Days */}
            <div className="flex flex-col items-center" data-id="element-81">
              <div className="relative" data-id="element-82">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-blue-600/20 rounded-2xl blur-xl" data-id="element-83"></div>
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 md:p-6 min-w-[70px] md:min-w-[120px]" data-id="element-84">
                  <div className="text-4xl md:text-7xl font-light text-white tabular-nums" data-id="element-85">
                    {formatNumber(timeLeft.days)}
                  </div>
                </div>
              </div>
              <div className="text-white/50 text-xs md:text-sm font-light tracking-widest mt-3 uppercase" data-id="element-86">
                Días
              </div>
            </div>

            {/* Hours */}
            <div className="flex flex-col items-center" data-id="element-87">
              <div className="relative" data-id="element-88">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-blue-600/20 rounded-2xl blur-xl" data-id="element-89"></div>
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 md:p-6 min-w-[70px] md:min-w-[120px]" data-id="element-90">
                  <div className="text-4xl md:text-7xl font-light text-white tabular-nums" data-id="element-91">
                    {formatNumber(timeLeft.hours)}
                  </div>
                </div>
              </div>
              <div className="text-white/50 text-xs md:text-sm font-light tracking-widest mt-3 uppercase" data-id="element-92">
                Horas
              </div>
            </div>

            {/* Minutes */}
            <div className="flex flex-col items-center" data-id="element-93">
              <div className="relative" data-id="element-94">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-blue-600/20 rounded-2xl blur-xl" data-id="element-95"></div>
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 md:p-6 min-w-[70px] md:min-w-[120px]" data-id="element-96">
                  <div className="text-4xl md:text-7xl font-light text-white tabular-nums" data-id="element-97">
                    {formatNumber(timeLeft.minutes)}
                  </div>
                </div>
              </div>
              <div className="text-white/50 text-xs md:text-sm font-light tracking-widest mt-3 uppercase" data-id="element-98">
                Min
              </div>
            </div>

            {/* Seconds */}
            <div className="flex flex-col items-center" data-id="element-99">
              <div className="relative" data-id="element-100">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-blue-600/20 rounded-2xl blur-xl" data-id="element-101"></div>
                <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 md:p-6 min-w-[70px] md:min-w-[120px]" data-id="element-102">
                  <div className="text-4xl md:text-7xl font-light text-white tabular-nums" data-id="element-103">
                    {formatNumber(timeLeft.seconds)}
                  </div>
                </div>
              </div>
              <div className="text-white/50 text-xs md:text-sm font-light tracking-widest mt-3 uppercase" data-id="element-104">
                Seg
              </div>
            </div>
          </div>
        </div>

        {/* Tagline */}
        <div className="animate-fade-in" style={{
        animationDelay: '0.6s'
      }} data-id="element-105">
          <p className="text-white/60 text-lg md:text-2xl font-light tracking-wide italic mb-8" data-id="element-106">
            La era Brixen está por comenzar...
          </p>

          {/* Additional content below tagline */}
          <div className="max-w-md mx-auto space-y-4" data-id="element-107">
            <p className="text-white/40 text-sm md:text-base font-light leading-relaxed" data-id="element-108">
              Prepárate para una nueva forma de restaurar tu crédito.
            </p>
            <p className="text-white/30 text-xs md:text-sm font-light" data-id="element-109">
              Algo grande viene en camino.
            </p>
          </div>
        </div>
      </div>

      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
      backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
      backgroundSize: '50px 50px'
    }} data-id="element-110"></div>
    </div>;
}